import gql from 'graphql-tag';

export const GET_MEMBER_CARD_LIST = gql`
  query(
    $member_no: ID!, $golf_group_code: String!, $begin_row: Int, $limit_rows: Int
  ){
    getMemberCardList(
      member_no: $member_no,
      golf_group_code: $golf_group_code,
      begin_row: $begin_row,
      limit_rows: $limit_rows
    ){
      MemberCardList{
        id
        member_no
        golf_group_code
        golf_code
        card_no
        created_at
        updated_at
        golf_name
      }
      count
    }
  },
`;

export const GET_GOLFCOURSE = gql`
    query ( $golf_group_code: String! ) {
        getGolfCourse (golf_group_code: $golf_group_code) {
            golf_code
            golf_name
        }
    }
`;

export const GET_GOLF_COURSE_NAME = gql`
    query ( $golf_code: String! ) {
      getGolfCourseName(golf_code: $golf_code){
        golf_name
      }
    }
`;

export const REGISTER_MEMBER_CARD_NO = gql`
  mutation (
    $member_no: Int!,
    $golf_group_code: String!,
    $golf_code: String!,
    $card_no: String!
    ){
      registerCardNo(
        member_no: $member_no,
        golf_group_code:  $golf_group_code,
        golf_code: $golf_code,
        card_no: $card_no
    ){
      result
    }
  }
`;

export const UPDATE_MEMBER_CARD_NO = gql`
  mutation(
    $id: ID!
    $golf_code: String!
    $card_no: String!
  ){
    updateCardNo(
      id: $id
      golf_code: $golf_code
      card_no: $card_no
    ){
      result
    }
  }
`;

export const DELETE_MEMBER_CARD_NO = gql`
  mutation(
    $id: ID!
  ){
    deleteCardNo(
      id: $id
    ){
      result
    }
  }
`;
